module.exports = __webpack_public_path__ + "img/cmp-pin-map.26ed0e8c.svg";